import { BicycleIcon as PhosphorBicycleIcon } from "@phosphor-icons/react";

interface Props {
  size?: number;
}

export function BicycleIcon(props: Props) {
  return (
    <PhosphorBicycleIcon
      aria-hidden="true"
      size={props.size || 24}
      color="currentColor"
      weight="bold"
    />
  );
}
